import API from '../../apis';
import actionTypes from './actionTypes';
import { action, generateErrorAction } from '../actions';

export const login = (userName, password) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.auth
        .login(userName, password)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(generateErrorAction(err, { failure: actionTypes.LOGIN_FAILURE, reject: actionTypes.LOGIN_REJECT }));
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.LOGIN_LOADING);
  const success = res => action(actionTypes.LOGIN_SUCCESS, res.payload);

  return request();
};

export const getMeInfo = () => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.auth
        .getMeInfo()
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_ME_INFO_FAILED,
              reject: actionTypes.GET_ME_INFO_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_ME_INFO_LOADING);
  const success = res => action(actionTypes.GET_ME_INFO_SUCCESS, res);
  return request();
};


export const sendMobileNumber = mobileNumber => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.auth
        .sendMobileNumber(mobileNumber)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FORGET_PASSWORD_FAILED,
              reject: actionTypes.FORGET_PASSWORD_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FORGET_PASSWORD_LOADING);
  const success = res => action(actionTypes.FORGET_PASSWORD_SUCCESS, res);
  return request();
};

export const checkVerificationCode = (verificationCode, mobileNumber) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.auth
        .checkVerificationCode(verificationCode, mobileNumber)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.CHECK_VERIFICATION_CODE_FAILED,
              reject: actionTypes.CHECK_VERIFICATION_CODE_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.CHECK_VERIFICATION_CODE_LOADING);
  const success = res => action(actionTypes.CHECK_VERIFICATION_CODE_SUCCESS, res);
  return request();
};

export const sendNewPassword = (password, mobileNumber, resetPassToken) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.auth
        .sendNewPassword(password, mobileNumber, resetPassToken)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.SET_NEW_PASSWORD_FAILED,
              reject: actionTypes.SET_NEW_PASSWORD_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.SET_NEW_PASSWORD_LOADING);
  const success = res => action(actionTypes.SET_NEW_PASSWORD_SUCCESS, res);
  return request();
};
